import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '../../theme';
import { useSpinnerStyles } from './Spinner.Styles';
export const Spinner = ({ size, color, className, ...props }) => {
    const theme = useTheme();
    const styles = useSpinnerStyles({
        ...{ size, color, ...props },
        theme
    });
    return _jsx("div", { className: `${styles.spinner} ${className}`, ...props });
};
